// src/components/Layout/Sidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ collapsed = false, darkMode = false }) => {
  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''} ${darkMode ? 'dark-mode' : ''}`}>
      <div className="sidebar-header">
        <div className="logo-container">
          <img 
            src="/logo512.png" 
            alt="Logo" 
            className="sidebar-logo-image" 
          />
        </div>
      </div>
      
      <div className="sidebar-content">
        <div className="menu-section">
          <div className="section-title">GERENCIAMENTO</div>
          <ul className="menu-items">
            <li>
              <NavLink to="/dashboard" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/dashboard-icon.png" alt="Dashboard" className="menu-icon-image" />
                </span>
                <span className="menu-text">Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/dre" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/report-icon.png" alt="Relatório" className="menu-icon-image" />
                </span>
                <span className="menu-text">Relatório DRE</span>
              </NavLink>
            </li>
            <li>
            <NavLink to="/categorias" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/category-icon.png" alt="Categorias" className="menu-icon-image" />
                </span>
                <span className="menu-text">Detalhes por Categoria</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/charts" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/chart-icon.png" alt="Gráficos" className="menu-icon-image" />
                </span>
                <span className="menu-text">Gráficos</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/não-categorizados" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/nao-categorizado.png" alt="Não Categorizados" className="menu-icon-image" />
                </span>
                <span className="menu-text">Itens não Categorizados</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/editar-categorizados" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/edit-icon.png" alt="Editar" className="menu-icon-image" />
                </span>
                <span className="menu-text">Editar Itens Categorizados</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/regimes-tributarios" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/tax-icon.png" alt="Regimes Tributários" className="menu-icon-image" />
                </span>
                <span className="menu-text">Regimes Tributários</span>
              </NavLink>
            </li>
          </ul>
        </div>
        
        <div className="menu-section">
          <div className="section-title">FERRAMENTAS</div>
          <ul className="menu-items">
            <li>
              <NavLink to="/periods" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/calendar-icon.png" alt="Períodos" className="menu-icon-image" />
                </span>
                <span className="menu-text">Gerenciador de Períodos</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/cash-entry" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/money-icon.png" alt="Dinheiro" className="menu-icon-image" />
                </span>
                <span className="menu-text">Entrada de Dinheiro</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/settings" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/settings-icon.png" alt="Configurações" className="menu-icon-image" />
                </span>
                <span className="menu-text">Configurações</span>
              </NavLink>
            </li>
          </ul>
        </div>
        
        <div className="menu-section">
          <div className="section-title">SUPORTE</div>
          <ul className="menu-items">
            <li>
              <NavLink to="/como-usar" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/help-icon.png" alt="Como Usar" className="menu-icon-image" />
                </span>
                <span className="menu-text">Como Usar</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/contato" className={({ isActive }) => isActive ? "active" : ""}>
                <span className="menu-icon">
                  <img src="/icons/contact-icon.png" alt="Contato" className="menu-icon-image" />
                </span>
                <span className="menu-text">Contato</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;